import { createClient } from '@sanity/client'

export const client = createClient({
    projectId: 'nh5z193g',
    dataset: 'production',
    useCdn: false, // set to `false` to bypass the edge cache
    apiVersion: '2022-03-07', // use current date (YYYY-MM-DD) to target the latest API version
    perspective: 'published',
    token: import.meta.env.VITE_SANITY_TOKEN,
})
